import axios from "axios";
import { API_URL, getAuthHeader } from ".";

export interface PushNotificationRecipient {
  userId: number;
  firstName: string | null;
  lastName: string | null;
  emailAddress: string | null;
  memberName: string | null;
  hasPushToken: boolean;
}

export interface PushSendResultRow {
  userId: number;
  email: string | null;
  status: string;
  message: string | null;
}

export interface PushSendSummary {
  attempted: number;
  sent: number;
  skipped: number;
  errors: number;
  rows: PushSendResultRow[];
}

class NotificationsApi {
  static getPushRecipients(search?: string) {
    const params = search?.trim() ? { search: search.trim() } : {};
    return axios.get<PushNotificationRecipient[]>(
      `${API_URL}/api/notifications/push/recipients`,
      { ...getAuthHeader(), params }
    );
  }

  static sendPush(userIds: number[], title?: string, body?: string) {
    return axios.post<PushSendSummary>(
      `${API_URL}/api/notifications/push/send`,
      { userIds, title, body },
      getAuthHeader()
    );
  }
}

export default NotificationsApi;
